import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { Pencil, CheckCircle } from "lucide-react";
import AssignmentForm from "./AssignmentForm";
import { PageHeader, AppCard, AppCardContent, AppButton } from "../ui";
import apiClient from "../../utils/apiClient";
import { getCurrentUser } from "../../utils/auth";
import "./Assignments.scss";

const AssignmentEditPage = () => {
  const { id } = useParams();
  const [assignment, setAssignment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saved, setSaved] = useState(false);
  const navigate = useNavigate();
  const assignmentsPath = getCurrentUser()?.usertype === 'instructor' ? '/i/assignments' : '/assignments';

  useEffect(() => {
    setLoading(true);
    apiClient.get(`/assignments/${id}`)
      .then(res => setAssignment(res.data.assignment))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <div className="text-center py-5"><Spinner /></div>;
  }

  if (saved) {
    return (
      <div className="asgn-form-page">
        <AppCard>
          <AppCardContent>
            <div className="asgn-success">
              <CheckCircle size={40} className="asgn-success__icon" />
              <h3 className="asgn-success__title">Assignment Updated!</h3>
              <p className="asgn-success__text">Your changes have been saved successfully.</p>
              <AppButton onClick={() => navigate(assignmentsPath)}>Go to Assignments</AppButton>
            </div>
          </AppCardContent>
        </AppCard>
      </div>
    );
  }

  return (
    <div className="asgn-form-page">
      <PageHeader
        title="Edit Assignment"
        description="Update assignment details and question pool."
        icon={Pencil}
        backButton
        onBack={() => navigate(assignmentsPath)}
      />
      <AssignmentForm
        onSuccess={() => setSaved(true)}
        assignment={assignment}
        editMode
      />
    </div>
  );
};

export default AssignmentEditPage;
